import React from 'react';
import { useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledTypography,
  StyledDialogCloseButton,
} from './styles.js';

const ConteudoParaPostModal = ({ open, onClose }) => {
  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <StyledDialogContent>
        <StyledDialogCloseButton onClick={onClose}>
          <CloseIcon />
        </StyledDialogCloseButton>

        <StyledDialogTitle>
          Fique mais perto das nossas marcas!
        </StyledDialogTitle>

        <StyledTypography>
          Atualizamos nosso menu lateral! <br />
          Agora, em Conteúdos e Comunicados, além das imagens para as suas redes, você encontra os links diretos para os nossos grupos de WhatsApp. <br />
          Confira!
        </StyledTypography>

      </StyledDialogContent>
    </StyledDialog>
  );
};

export default ConteudoParaPostModal;
